import type { FaireProductEntity } from "../../entity_types/product";

export const p_rn9xk57prk: FaireProductEntity = {
  token: "p_rn9xk57prk",
  type: "product",
  name: "Halloween Theme Hand-Embroidered Hair Barrette ✅",
  brandToken: "b_pymvm8uh5h",
  brandName: "Quince Fables",
  imageUrl:
    "https://cdn.faire.com/fastly/818ca03e51eec6128e541f725a94e6c68c1d02c069cedee9db5d3e88b1356156.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/563d4864915b872f4e0406cedf8ad6bb3a5332afd9ce4d9e296b6a986b604632.jpeg",
    "https://cdn.faire.com/fastly/6128849cb98d05a09ee7e4939c43347853d813b52ec39397f440f9b3926bcfc5.jpeg",
    "https://cdn.faire.com/fastly/ebf16e49de18087caf32d74c8d7da4692a55630f9163f07356b4991760206e22.jpeg",
    "https://cdn.faire.com/fastly/54866202e85e58884a5b6ca0165d5a2596d1f3fc687e2fd250f5080ceb4a33de.jpeg",
    "https://cdn.faire.com/fastly/47fa9baeaf4d944d949b0811664e2aad9b4e91c1c6b80645276c9cafd5bae9c7.jpeg",
    "https://cdn.faire.com/fastly/7dfc0656c45411dc00e8a7b203d3921036449b6eb477b2514adbfbd299b6d711.jpeg",
    "https://cdn.faire.com/fastly/6f2283b718eb209aec692b906ffe728e1e6e330cce1e5971a143e91da7b7c44a.jpeg",
    "https://cdn.faire.com/fastly/a560aeeb40b713bf57d11f280eda0d74ac2912041b5dc72029ef5e4f64bf6903.jpeg",
  ],
  priceDollars: 3.8,
  description:
    '* Halloween cut-off dates:\n• Place the order by Sep 28 to receive it by Oct 15, so you will have about 2 weeks to display and sell the items.\n• Order placed later than Sep 28 will be delivered after Oct 26.\n\nHalloween Theme Hand-Embroidered Hair Clip\n\n★ About\n• Each hair clip is hand embroidered on sturdy stainless steel clip.\n• These adorable, trendy and feminine snap clips are the perfect back to school hair clips or any other occasions: go to walk, picnic. These bow hair clips will complete any outfit and make for a great gift. You can use them for holding bangs back.\n• Size: 2.7"\n\n★ Care:\n• Wash: Fill a clean glass with cool water and add a drop of mild laundry detergent. Let the clip soak for 5 mins. Remove the clip and wash with cool water.\n• Use a clean towel to pat down the clip. Set it on a towel to dry.',
  tags: [],
  msrpDollars: 8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:53:33.970Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
